function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg164(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.71 14.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 90.71,
    y1: 0.13,
    x2: 88.71,
    y2: 0.13,
    style: {
      fill: "none",
      stroke: "#e20e17",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.69,
    y1: 0.13,
    x2: 3.01,
    y2: 0.13,
    style: {
      fill: "none",
      stroke: "#e20e17",
      strokeMiterlimit: 10,
      strokeWidth: ".25px",
      strokeDasharray: "0 0 4.03 2.02"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 0.13,
    x2: 0,
    y2: 0.13,
    style: {
      fill: "none",
      stroke: "#e20e17",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 90.71,
    y1: 14.3,
    x2: 88.71,
    y2: 14.3,
    style: {
      fill: "none",
      stroke: "#e20e17",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.69,
    y1: 14.3,
    x2: 3.01,
    y2: 14.3,
    style: {
      fill: "none",
      stroke: "#e20e17",
      strokeMiterlimit: 10,
      strokeWidth: ".25px",
      strokeDasharray: "0 0 4.03 2.02"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 14.3,
    x2: 0,
    y2: 14.3,
    style: {
      fill: "none",
      stroke: "#e20e17",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg164);
export default __webpack_public_path__ + "static/media/164.bc8d7c48eeb9b71065eb7caee620bbb9.svg";
export { ForwardRef as ReactComponent };